

















































import { Prop, Component, Vue } from 'vue-property-decorator'
import { TypeformResponseAnswer } from '@/api/model/typeform/typeform-response-answer'
import { TypeformResponse } from '@/api/model/typeform/typeform-response'
import FieldTypeDate from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeDate.vue'
import FieldTypeNumber from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeNumber.vue'
import FieldTypeBoolean from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeBoolean.vue'
import FieldTypeUrl from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeUrl.vue'
import FieldTypeEmail from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeEmail.vue'
import FieldTypeChoice from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeChoice.vue'
import FieldTypeText from '@/views/Typeform/Responses/Detail/FieldType/FieldTypeText.vue'
import HighlightReferences from '@/views/Typeform/Responses/Detail/HighlightReferences.vue'

@Component({
    components: {
        HighlightReferences,
        FieldTypeDate,
        FieldTypeNumber,
        FieldTypeBoolean,
        FieldTypeUrl,
        FieldTypeEmail,
        FieldTypeChoice,
        FieldTypeText,
    },
})
export default class TypeformResponsesDetailAnswer extends Vue {
    @Prop({ required: true }) response!: TypeformResponse

    getDefinitionForAnswer(answer: TypeformResponseAnswer): string {
        return this.response.definition.fields.find(v => v.fieldId === answer.fieldId).fieldTitle
    }
}
